import gql from 'graphql-tag'
import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'

const loggedInUser = gql`
  query LoggedInUser {
    loggedInUser {
      id
    }
  }
`

export const AuthStatusEnum = {
  authorized: 'authorized',
  unauthorized: 'unauthorized',
  loading: 'loading',
}

export const withAuthStatus = compose(
  graphql(loggedInUser, {
    name: 'auth',
  }),
  withProps(({ auth }) => ({
    authStatus: getAuthStatus(auth),
    userId: getUserId(auth),
  })),
)

function getAuthStatus(authData) {
  if (authData.loading) return AuthStatusEnum.loading

  if (authData.loggedInUser && authData.loggedInUser.id)
    return AuthStatusEnum.authorized

  return AuthStatusEnum.unauthorized
}

function getUserId(authData) {
  if (authData.loggedInUser && authData.loggedInUser.id) {
    return authData.loggedInUser.id
  }
  return undefined
}



// WEBPACK FOOTER //
// ./src/modules/auth/withAuthStatus.js